import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';


const ModalLogisticDelete = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    invoice: { setInvoice },
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.deleteLogistics');
  const onClose = () => {
    closeSingleModal('deleteLogistics');
    setInvoice('selected.logistic', -1);
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Remover logística"
      height={'auto'}
      width={'30vw'}
    >
      <Form.Export.Logistic.Delete />
    </Modal>
  );
};

export default ModalLogisticDelete;
